import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";

export default function Shop() {
  const [color, setColor] = useState(null);
  const { data: products = [], isLoading } = useQuery({
    queryKey: ["products", "official", color],
    queryFn: async () => (await api.get(`/products?origin=official${color ? `&color=${color}` : ""}`)).data,
  });
  const colors = ["Black", "Grey", "White"];

  return (
    <div className="mx-auto max-w-[1600px] px-5 py-12 md:px-8" data-testid="shop-page">
      <Seo title="Shop — The Hoodie Project®" description="Shop the Classic Hoodie in Black, Grey and White. Sizes M–XXL." />
      <div className="mb-10 border-b border-border pb-6">
        <p className="text-xs tracking-[0.3em] text-muted-foreground">OFFICIAL STORE</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tighter md:text-7xl">SHOP</h1>
      </div>

      <div className="mb-8 flex flex-wrap items-center gap-3">
        <span className="mr-2 text-xs tracking-[0.2em] text-muted-foreground">COLOR:</span>
        <button onClick={() => setColor(null)} data-testid="filter-all"
          className={`border px-4 py-2 text-xs tracking-widest transition-colors ${!color ? "border-white bg-white text-black" : "border-border hover:border-white"}`}>ALL</button>
        {colors.map((c) => (
          <button key={c} onClick={() => setColor(c)} data-testid={`filter-${c.toLowerCase()}`}
            className={`border px-4 py-2 text-xs tracking-widest transition-colors ${color === c ? "border-white bg-white text-black" : "border-border hover:border-white"}`}>{c.toUpperCase()}</button>
        ))}
      </div>

      {isLoading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : products.length === 0 ? (
        <p className="text-muted-foreground" data-testid="shop-empty">No hoodies match that filter.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
